/**
* Pinned Scrolling Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Pinned Scrolling Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'pinned-scrolling-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      pinScrollingContent();
      // $( window ).on( 'resize', function() {
      //   pinScrollingContent();
      // } );

      let resizeId;
      $( window ).resize( function() {
        clearTimeout( resizeId );
        resizeId = setTimeout( doneResizing, 500 );
      } );

      function doneResizing() {
        pinScrollingContent();
      }

      function pinScrollingContent() {
        const query = window.matchMedia( '(prefers-reduced-motion: reduce)' );
        if ( query.matches || window.innerWidth < 1024 ) {
          // DO NOT FIRE ANIMATIONS
          ScrollTrigger.getById( 'content-pin' ).kill( true );
        } else {
          if ( $( '.pinned-scrolling-content .pinned-container' ).length > 0 ) {
            $( 'section.pinned-scrolling-content' ).each( function() {
              const st = ScrollTrigger.create( {
                trigger: $( this ),
                pin: $( this ).find( '.pinned-container' ),
                start: 'top top+=100px',
                end: 'bottom center+=25px',
                scrub: 1.25,
                id: 'content-pin',
                pinSpacing: false,
                anticipatePin: true,
              // markers: true,
              } );
            } );
          }
          let sectionHeight = 0;
          if ( $( window ).width() > '1023' && $( '.pinned-scrolling-content_content' ).length > 0 ) {
            $( '.pinned-scrolling-content_content' ).each( function() {
              sectionHeight = sectionHeight + $( this ).height();
              const cards = gsap.timeline( {
                scrollTrigger: {
                  trigger: $( this ),
                  pin: false,
                  start: 'top bottom',
                  end: 'top center',
                  scrub: 1,
                // markers: true,
                },
              } );
              // cards.from( $( this ), {opacity: 0, y: 80} );
            } );
          }
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'pinned-scrolling-content', COMPONENT );
} )( app );
